module.exports = __webpack_public_path__ + "img/bg-cant-find@2x.3428c332.jpeg";